import React, { Component } from 'react'
import GenericEvent from './GenericEvent'

const NOTE_ICON_SRC = require('images/svg/note-navy.svg')

export default class NoteLoggingEvent extends Component {
  render() {
    const eventProps = {
      iconSrc: NOTE_ICON_SRC,
      isNote: true,
      eventLabel: "added a note",
      ...this.props
    }
    return (
      <GenericEvent {...eventProps } />
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/NoteLoggingEvent.js